import { ProductSupportUI } from "./ProductSupportUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";

export function ProductSupport({ product }: Pick<StandardProps, "product">) {
  const { sellingProductType } = product;
  const {
    variant: { displayCode },
  } = useVariant(product);
  if (sellingProductType !== "Laptops") return null;
  const productVariantUrl = `https://productsupport.johnlewis.com/invoke/productcode?code=${displayCode}&origin=Web&referrer=PDP`;
  return <ProductSupportUI url={productVariantUrl} />;
}
